// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from 'modules/queries/api';

/**
 * @param {import('club-sauce/public/account/user/index.raw').LWApiPublicAccountUserListParamsRawI} params
 * @param {import('@tanstack/react-query').UseQueryOptions} options
 */
const useAccountUserList = (params, { keepPreviousData, enabled } = {}) =>
	useQuery({
		queryKey: ['/account/user/list', params],
		queryFn: () => api.account.user.apiRaw.list(params),
		keepPreviousData,
		enabled,
	});

export default useAccountUserList;
